const buildURIByObject = params => {
  const paramsNames = Object.keys(params)
  let uri = ''

  paramsNames.forEach((name, index) => {
    uri += index === (paramsNames.length - 1)
      ? `${name}=${params[name]}`
      : `${name}=${params[name]}&`
  })

  return uri
}

const DEFAULT_SCHEME = 'https://'
const WEB_PROTOCOLS = ['http:', 'https:']
const PRINTABLE_ASCII_PATTERN = /^[\x21-\x7E]+$/
const SCHEME_PATTERN = /^[a-z][a-z\d+.-]*:\/\//i
const HOST_PATTERN = /^[a-z\d-]+(\.[a-z\d-]+)+$/i

const toWebUrl = value => {
  const trimmedValue = typeof value === 'string' ? value.trim() : ''

  if (!PRINTABLE_ASCII_PATTERN.test(trimmedValue)) {
    return null
  }

  const candidate = SCHEME_PATTERN.test(trimmedValue) ? trimmedValue : DEFAULT_SCHEME + trimmedValue

  try {
    const url = new URL(candidate)

    return WEB_PROTOCOLS.includes(url.protocol) && url.username === '' && url.password === '' && HOST_PATTERN.test(url.hostname)
      ? candidate
      : null
  } catch (e) {
    return null
  }
}

export {
  buildURIByObject,
  toWebUrl
}
